export function navigateToSubmission(submissionId?: string): string {
  if (!submissionId) return "#not-found";
  return `/submissions/${submissionId}`;
}
